import React, {Component} from 'react';
import items from '../../assets/json/tftitems.json';

class MemberAugment extends Component{
    constructor() {
        super();
        this.state = { currentAugments : null}
    }
    componentDidMount(){
        let tabAugment = [];
        this.props.augments.forEach(element => {
            element.forEach((augment) => {
                if(tabAugment.find((item) => item.name === augment) === undefined) {
                   tabAugment.push({'name': augment,'nb' : 1})
                } else {
                   tabAugment.find((item) => item.name === augment)['nb'] += 1
                }
                
            })
        });
        
        tabAugment.sort((a,b) => {if(a.nb < b.nb) { return 1 } else {return -1}})
        this.setState({currentAugments: tabAugment});
    }
    getAugmentPath(augment) {
        //augment = TFT6_Augment_PortableForge
        //image name = portableforge2.tft_set6.png
        let name = augment.split('_')[2];
        let set = augment.split('_')[0];
        let setNumber = set.split("TFT")[1];
        return name.toLowerCase()+".tft_set"+setNumber+".png"

        ///                     lol-game-data/assets/ASSETS/Maps/Particles/TFT/Item_Icons/Augments/Hexcore/Dragonbane-Crest-II.TFT_Set7.png
        //https://raw.communitydragon.org/latest/game/assets/maps/particles/tft/item_icons/augments/hexcore/

    }
    convertImageToRaw(itemName) {
        let temp = items.find((item) => item.nameId === itemName)
        if(temp !== undefined)
            return temp.loadoutsIcon.replace("/lol-game-data/assets/ASSETS/","https://raw.communitydragon.org/latest/game/assets/").toLocaleLowerCase();
        else {
            return "";
        }
    }

    returnName(augment) {
        let temp = items.find((item) => item.nameId === augment.name);
        if(temp !== undefined) {
            return temp.name;
        } else {
            return augment.name;
        }
    }
    render() {
        if(this.state.currentAugments != null ){ 
            return(
                <div className='flex flex-col justify-items-start text-left'>
                    {this.state.currentAugments.slice(0, 10).map((augment,index) => (
                        <div key={index} className={index % 2 ? 'bg-slate-200 flex flex-row' : 'flex flex-row'}>
                            <div className='basis-1/2 flex pl-2 leading-8'>{this.returnName(augment)}</div>
                            <div className='basis-1/4 flex flex-col'>
                                <div className={`text-center hexagon hexagon-augment`} title={this.returnName(augment)}>
                                    <div className={`augment ${augment.name}`}>
                                        <img className='-mt-[1px] ml-[5px] rounded-full ' style={{width: '22px',height: '22px',}} src={this.convertImageToRaw(augment.name)} alt={augment.name.split('_')[2]}/>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                <div className='align-middle' style={{lineHeight: '29px'}}>x {augment.nb}</div>
                            </div>    
                        </div>
                    ))}  
                </div>
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default MemberAugment